import React, { useRef } from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Feather } from '@expo/vector-icons';
import { spacing } from '../../theme';
import { useColors, ThemeColors } from '../../hooks/useColors';
import type { Chat } from '../../types/chat';
import { useChatActions } from '../../hooks/useChatActions';
import { ChatList } from './ChatList';
import { Swipeable } from 'react-native-gesture-handler';
import { platformAlert } from '../../utils/platformAlert';

interface ArchivedChatListProps {
  chats: Chat[];
}

export function ArchivedChatList({ chats }: ArchivedChatListProps) {
  const colors = useColors();
  const styles = createStyles(colors);
  const { deleteChat } = useChatActions();
  const swipeableRefs = useRef<{ [key: string]: Swipeable | null }>({});

  const handleDelete = (chat: Chat) => {
    platformAlert(
      'Delete Chat',
      'Are you sure you want to permanently delete this chat?',
      [
        { text: 'Cancel', style: 'cancel' },
        {
          text: 'Delete',
          onPress: () => {
            deleteChat.mutate(chat.id);
            swipeableRefs.current[chat.id]?.close();
          },
          style: 'destructive',
        },
      ]
    );
  };

  const renderRightActions = (chat: Chat) => {
    return (
      <View style={styles.rightActions}>
        <TouchableOpacity 
          style={styles.deleteAction}
          onPress={() => handleDelete(chat)}
        >
          <Feather name="trash-2" size={24} color="#fff" />
          <Text style={styles.actionText}>Delete</Text>
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <ChatList 
      chats={chats} 
      customRightActions={renderRightActions}
      customSwipeableRefs={swipeableRefs}
    />
  );
}

const createStyles = (colors: ThemeColors) => StyleSheet.create({
  rightActions: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  deleteAction: {
    backgroundColor: colors.error,
    justifyContent: 'center',
    alignItems: 'center',
    width: 100,
    height: '100%',
    paddingHorizontal: spacing.md,
  },
  actionText: {
    color: colors.surface,
    marginTop: spacing.xs,
    fontSize: 12,
  },
}); 